<template>
    <div>
        <el-form ref="searchForm" :inline="true" :model="searchForm" @submit.native.prevent>
            <el-form-item label="代理商名称：">
                <el-input v-model.trim="searchForm.name" @keyup.enter.native="getAgentListHandle" clearable></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" plain @click="getAgentListHandle">搜索</el-button>
                <el-button type="success" plain @click="showAddNewAgentHandle">新增</el-button>
                <!-- <el-button type="success" plain @click="getKeyss">获取密钥</el-button> -->
            </el-form-item>
        </el-form>
        <el-table :data="tbpg.tableData"
		  border
		  fit
		  highlight-current-row
		  style="width: 100%;"
		  :header-cell-style="{background:'#f5f5f5'}"
		>
            <el-table-column type="index" width="50" align="center"></el-table-column>
            <el-table-column prop="sysUserId" label="账号ID" align="center"></el-table-column>
            <el-table-column prop="name" label="代理商名称 " align="center"></el-table-column>
            <el-table-column prop="sysUserAccountName" label="账号" align="center"></el-table-column>
            <el-table-column prop="sysUserMobile" label="手机号" align="center"></el-table-column>
            <el-table-column prop="createTime" label="创建时间" align="center"></el-table-column>
            <el-table-column prop="createOptName" label="添加人" align="center"></el-table-column>
            <!-- <el-table-column prop="profit" label="销售折扣" align="center"></el-table-column> -->
            <el-table-column prop="commissionBalanceRmb" label="代理商返现（元）" align="center"></el-table-column>
            <el-table-column prop="prechargeBalanceRmb" label="预充值余额（元）" align="center"></el-table-column>
            <el-table-column prop="allIccid" label="卡总数" align="center"></el-table-column>
            <el-table-column prop="activeIccid" label="激活卡数" align="center"></el-table-column>
            <el-table-column label="激活率"  align="center">
                <template slot-scope="scope">{{ ((Number(scope.row.activeAll)*100).toFixed(2)) }}%</template>
            </el-table-column>
            <el-table-column label="操作" align="center" fixed="right">
                <template slot-scope="scope">                    
                    <el-button type="text" size="small" @click="showEditAgentInfo(scope.row)">编辑</el-button>
                    <el-button type="text" size="small" v-if="hasAuthority('reset_password')"  @click="resetPwdHandle(scope.row.sysUserId)">重置密码</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tbpg.currentPage"
            :page-sizes="[15, 50, 100, 500]"
            :page-size="tbpg.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tbpg.total">
        </el-pagination> 
        <el-dialog :append-to-body="true"  :title="title" :visible.sync="addNewAgentVisibale" width="600px" @close="cancel" :close-on-click-modal="false">
            <el-form ref="newAgentForm" :model="newAgentForm" :rules="newAgentFormRules" label-width="120px">
                <el-form-item label="姓名：" prop="name">
                    <el-input v-model.trim="newAgentForm.name" :disabled="accountDisabled" clearable></el-input>
                </el-form-item>
                <el-form-item label="登录账号：" prop="sysUserAccountName">
                    <el-input v-model.trim="newAgentForm.sysUserAccountName" :disabled="accountDisabled" clearable></el-input>
                </el-form-item>
                <el-form-item v-if="addFlag" label="登录密码：" prop="sysUserAccountPwd">
                    <el-input v-model.trim="newAgentForm.sysUserAccountPwd" show-password clearable></el-input>
                </el-form-item>
                <el-form-item label="绑定手机号：" prop="sysUserMobile">
                    <el-input v-model.trim="newAgentForm.sysUserMobile" clearable></el-input>
                </el-form-item>
                <!-- <el-form-item label="密钥："    v-if="hasAuthority('update_balance')" >
                    <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 20}" maxlength="1000" show-word-limit v-model.trim="newAgentForm.keyss" clearable></el-input>
                </el-form-item> -->
                <!-- <el-form-item label="销售折扣：" prop="profit">
                    <el-row>
                        <el-col :span="22">
                            <el-input type="number" v-model.number.trim="newAgentForm.profit" placeholder="请输入销售折扣0~100" clearable></el-input>
                        </el-col>
                        <el-col :span="2" class="center">%</el-col>    
                    </el-row>
                    <el-row>
                        <span>提醒：销售折扣 = （100 - 返点比例）%</span>
                    </el-row>                    
                </el-form-item> -->
                <el-form-item  v-if="hasAuthority('update_balance')" label="是否自收款：" prop="isCollect">
                    <el-select v-model="newAgentForm.isCollect" placeholder="">
                        <el-option label="是" value="1"></el-option>
                        <el-option label="否" value="0"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="addOrEditNewAgentHandle">确 定</el-button>
            </div>   
        </el-dialog>    


        <el-dialog :append-to-body="true"  title="密钥数据" :visible.sync="keyssVisible" width="600px" @close="cancel" :close-on-click-modal="false" class="keyssVisible">
            <h5>公 钥：</h5>
            <p>{{keyssData.publicKey}}</p><br><br><br>
            <h5>密 钥：</h5>
            <p>{{keyssData.privateKey}}</p>
        </el-dialog>        
    </div>
</template>

<script>
import {addNewAgent, getAgentList, updateAgentInfo} from '@/api/customers.js'
import {resetUserPwd} from '@/api/user.js'
import {mapGetters } from "vuex";
import common from '@/utils/common.js'
export default {
    data(){
        return {
            searchForm: {
                name: ''
            },
            tbpg: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0                 
            },            
            addNewAgentVisibale: false,
            title: '新增代理商',
            accountDisabled: false,
            newAgentForm: {
                name: '',
                sysUserAccountName: '',
                sysUserAccountPwd: '',
                sysUserMobile: '',
                profit: '90',
                bankName: '',
                idCard: '',
                subbranch: '',
                bankCardNo: '',
                accountName: '',
                bindMobile: '',
                alipayAccount: '',
                keyss:'',
                isCollect: ''
            },
            addFlag: true,
            currentId: '',
            newAgentFormRules: {
                name: [{required: true, message: '请输入代理商名称', trigger: 'blur'}],
               // sysUserAccountName: [{required: true, validator: this.checkAccount, trigger: 'blur'}],
                sysUserAccountPwd: [{required: true, validator: this.checkPassword,trigger: 'blur'}],
                sysUserMobile: [{required: true, validator: this.checkPhone, trigger: 'blur'}],
                profit: [{required: true, validator: this.checkInt, trigger: 'blur'},
                        { type: 'date', min: 0, max: 100, message: '可取范围 0 ~ 100', trigger: 'blur' }]
            },

            keyssVisible: false,

            keyssData:{
                privateKey:'',
                publicKey:''
            }
        }
    },
    computed:{
        ...mapGetters("menu", {
            hasAuthority: "hasAuthority" 
        })
    },
    methods: {
        resetPwdHandle(id){
            resetUserPwd({'id': id}).then(res => {
                this.$message.success(res.data.message)
            })
        },
        cancel(){
            this.addNewAgentVisibale = false;
            this.$refs.newAgentForm.resetFields(); 
            for (let key in this.newAgentForm) {
                this.newAgentForm[key] = "";
            }
        },
        getAgentListHandle($event){
            common.resetCurrentPage(this, $event, 'tbpg');
            var data = common.getRequestParams(this, 'tbpg', this.searchForm);  
            getAgentList(data).then(res => {
                common.listCallback(this, res, 'tbpg');
            })
        },
        showAddNewAgentHandle(){
            this.title = '新增代理商';
            this.addNewAgentVisibale = true;
            this.accountDisabled = false;
            this.addFlag = true;
        },
        showEditAgentInfo(row){
            this.title = '修改代理商信息';
            this.addNewAgentVisibale = true;
            this.accountDisabled = true;
            this.addFlag = false;
            this.currentId = row.id;
            row.isCollect =  row.isCollect.toString();
            for(var key in this.newAgentForm){                
                if(typeof(row[key]) == 'string'){
                    this.newAgentForm[key] = (row[key]).replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
                }else{
                    this.newAgentForm[key] = row[key];
                }                
            }
        },
        addOrEditNewAgentHandle(){
            this.$refs.newAgentForm.validate(valid => {
                if(valid){
                    var data = this.newAgentForm;     
                    if(this.addFlag){
                        addNewAgent(data).then(res => callback(res))
                    }else{
                        data.id = this.currentId;
                        updateAgentInfo(data).then(res => callback(res))                        
                    }
                }
                var _this = this;
                function callback(res){
                    if(res.data.code == 200){
                        _this.$message.success(res.data.message)
                        _this.getAgentListHandle();
                        _this.addNewAgentVisibale = false;
                        
                    }else{
                        _this.$message.error(res.data.message)
                    }                     
                }
            })
        },        
        handleSizeChange(val){
            this.tbpg.pageSize = val;
            this.getAgentListHandle();
        },
        handleCurrentChange(val){
            this.tbpg.currentPage = val;
            this.getAgentListHandle();
        },

        getKeyss(){
            common.sysRequest('external/get/keyss', null, 'get').then(res => {
                if(res.data.code == 200){
                    this.$message.success(res.data.message);
                    this.keyssData = res.data.data;
                    this.keyssVisible = true;
                }else{
                    this.$message.error(res.data.message);
                }
                
            })
        } 
    },
    created () {
        this.getAgentListHandle()
    }  
}
</script>

<style lang="less" scoped>
    .keyssVisible{
        h5{
            font-weight: bold;
            line-height: 30px;
        }
    }
</style>

